export default __webpack_public_path__ + "static/media/ic-number.470948e3.svg";